import { ComponentStyleConfig } from "@chakra-ui/react";
import { SystemStyleInterpolation } from "@chakra-ui/styled-system";
import { mergeWith } from "@chakra-ui/utils";

const simpleStyles: SystemStyleInterpolation = {
  group: {
    ".mb-input-clear": {
      display: "none",
    },
    _focusWithin: {
      ".mb-input-clear": {
        display: "flex",
      },
    },
  },
  field: {
    width: "unset",
    minWidth: "unset",
    "&:is(select)": {
      width: "100%",
    },
    fontSize: 14,
    fontWeight: 400,
    textColor: "gray.600",
    borderWidth: 1,
    borderRadius: "4px",
    borderColor: "gray.300",
    bg: "white",
    _focus: {
      borderColor: "primary.500",
    },
    _placeholder: {
      color: "gray.400",
    },
    _invalid: {
      borderColor: "error.600",
    },
    "&&[data-na]": {
      opacity: 1,
      borderColor: "gray.100",
      bg: "gray.100",
      textColor: "transparent",
      _placeholder: {
        color: "transparent",
      },
    },
    _readOnly: {
      color: "gray.600",
      bg: "gray.50",
      borderColor: "gray.50",
    },
    "&[inputmode=numeric]": {
      fontVariantNumeric: "lining-nums tabular-nums",
    },
  },
  element: {
    color: "gray.400",
    _disabled: {
      opacity: 0.5,
      cursor: "not-allowed",
    },
    "&&[data-na]": {
      visibility: "hidden",
    },
  },
};

const InputTheme: ComponentStyleConfig = {
  baseStyle: {
    field: {
      lineHeight: "20px",
      fontSize: "14px",
      "&[type=date][data-blank]": {
        opacity: 0,
      },
      "&[type=date][data-blank]:focus": {
        opacity: 1,
      },
      _placeholder: {
        color: "gray.400",
      },
      _disabled: {
        opacity: 1,
      },
      _readOnly: {
        color: "gray.700",
        bg: "gray.50",
      },
    },
  },
  variants: {
    simple: simpleStyles,
    "simple-table": mergeWith({}, simpleStyles, {
      field: {
        border: 0,
        height: "100%",
        paddingInline: "16px",
        py: 0,
        bg: "none",
        borderRadius: 0,
        _readOnly: {
          cursor: "default",
        },
      },
    }),
  },
  sizes: {
    lg: {
      addon: {
        borderRadius: 0,
      },
    },
    sm: {
      field: {
        height: "36px",
        py: "7px",
        fontSize: 14,
        fontWeight: 400,
      },
      element: {
        "& svg": {
          width: "16px",
          height: "16px",
        },
      },
    },
    md: {
      field: {
        height: "48px",
        py: "13px",
        px: "16px",
      },
    },
    xs: {
      field: {
        height: "32px",
        px: "16px",
      },
      element: {
        width: "unset",
        height: "unset",
        ".mb-input-clear": {
          width: "30px",
          height: "30px",
          padding: 0,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          svg: {
            width: "20px",
            height: "20px",
          },
        },
      },
    },
  },
};

export default InputTheme;
